import {Grid, Theme, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import React from 'react';
import {Group} from '../../../graphql/groups.datatypes';
import {getCopy} from '../../../utils/getCopy';
import {allHtmlLinksNewWindow} from '../../../utils/allHtmlLinksNewWindow';

const whatsIncludedBgImage = require('../../../../assets/img/whats-included-bg.svg');

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(0),
    paddingBottom: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(3),
    },
  },
  bodyContainer: {
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(3),
    },
  },
  heading: {
    paddingBottom: theme.spacing(2),
    fontFamily: 'Recoleta-SemiBold',
  },
  subHeadings: {
    color: theme.palette.secondary.main,
    fontSize: 18,
    fontFamily: 'Nunito',
    fontWeight: 'bold',

    '&:after': {
      content: '""',
      display: 'block',
      height: 2,
      width: 64,
      backgroundColor: '#242424',
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(4)
    }
  },
  body: {
    paddingBottom: theme.spacing(2),
    fontFamily: 'Nunito',
    fontSize: 18,
    letterSpacing: 30 / 1000,
  },
  button: {
    borderRadius: 0,
    borderWidth: 2,
    textTransform: 'none',
    background: '#f2f2f2',
    [theme.breakpoints.down('sm')]: {
      marginRight: theme.spacing(2),
    },
    [theme.breakpoints.up('md')]: {
      marginRight: theme.spacing(8),
    },

    '&:hover, &.Mui-focusVisible': {
      borderRadius: 0,
      borderWidth: 2,
      textTransform: 'none',
    },
  },
  includedBox: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.white,
    fontFamily: 'Nunito',
    fontSize: 18,
    marginTop: theme.spacing(4),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    position: 'relative',
    transformStyle: 'preserve-3d',

    [theme.breakpoints.down('xs')]: {
      paddingTop: theme.spacing(2.5),
      paddingBottom: theme.spacing(2.5),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },

    '&:before': {
      content: '""',
      display: 'block',
      width: '92%',
      height: '80%',
      position: 'absolute',
      right: -theme.spacing(2.5),
      bottom: -theme.spacing(2.5),
      backgroundImage: `url(${whatsIncludedBgImage})`,
      backgroundRepeat: 'repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'bottom right',
      transform: 'translateZ(-1px)',

      [theme.breakpoints.down('sm')]: {
        width: '98%',
        height: '98%',
        right: -theme.spacing(1.25),
        bottom: -theme.spacing(2.5),
      },
    },

    '& h3': {
      fontFamily: 'Nunito',
      fontWeight: 'bold',
      color: theme.palette.white,
      marginBottom: theme.spacing(3)
    },

    '& ul': {
      columnCount: 2,
      listStyleType: 'circle',

      [theme.breakpoints.down('xs')]: {
        columnCount: 1,
      },
    },

    '& li': {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      paddingBottom: theme.spacing(1),

      [theme.breakpoints.down('xs')]: {
        marginLeft: theme.spacing(4),
        marginRight: theme.spacing(4),
      }
    },

    '& a' : {
      color: theme.palette.white,
      fontWeight: 'bold',
      textDecoration: 'underline',
      //
      // '&:hover': {
      //   color: theme.palette.white,
      // },
    },
  }
}));

const ThankYou = (props: {
  group: Group;
}) => {
  const classes = useStyles();
  const {group} = props;
  const insuranceCopy = group.description_insurance && allHtmlLinksNewWindow(group.description_insurance);
  const content = getCopy(group.default_authorize_members ? 'thank-you-approved' : 'thank-you-pending') + (insuranceCopy ? '<br/><br/>' + insuranceCopy : '');

  return (
      <React.Fragment>
        <Grid className={classes.root} container spacing={3}>
          <Grid item xs={12} className={classes.bodyContainer}>
            <Typography variant="h1" className={classes.heading}>
              Thank you
            </Typography>

            <div className={classes.includedBox} dangerouslySetInnerHTML={{__html:  content}}/>
          </Grid>
        </Grid>
      </React.Fragment>
  );
};

export default ThankYou;
